var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('vbt-search',{attrs:{"items":_vm.searchFieldsConfig},on:{"reset":_vm.onResetSearch,"search":_vm.onSearch},model:{value:(_vm.searchData),callback:function ($$v) {_vm.searchData=$$v},expression:"searchData"}}),_c('vbt-content-box',{attrs:{"loading":_vm.isLoading,"loading-error":_vm.loadingError,"no-content":_vm.noContent,"go-back-btn":_vm.goBack,"title":"Information"}},[_c('vbt-table',{attrs:{"items":_vm.orders,"headers":_vm.headers,"show-details-action":""},on:{"click:details":function (ref) {
      var id = ref.outerId;

      return _vm.$router.push({
        name: 'order',
        params: { id: id },
        query: { suffix: _vm.suffix },
      });
}},scopedSlots:_vm._u([{key:"outerId",fn:function(ref){
      var outerId = ref.item.outerId;
return [_c('router-link',{staticClass:"info--text",attrs:{"to":{
            name: 'order',
            params: { id: outerId },
            query: { suffix: _vm.suffix },
          }}},[_vm._v(" "+_vm._s(outerId)+" ")])]}},{key:"status",fn:function(ref){
          var status = ref.item.status;
return [_c('kernel-status-badge',{attrs:{"status":_vm.orderStatusEnumByValue[status]}},[_vm._v(" "+_vm._s(status)+" ")])]}},{key:"validationStatus",fn:function(ref){
          var validationStatus = ref.item.validationStatus;
return [_c('kernel-status-badge',{attrs:{"status":_vm.validationStatusEnumByValue[validationStatus]}},[_vm._v(" "+_vm._s(validationStatus)+" ")])]}},{key:"created",fn:function(ref){
          var created = ref.item.created;
return [_vm._v(" "+_vm._s(_vm.formatDate(created))+" ")]}},{key:"expires",fn:function(ref){
          var expires = ref.item.expires;
return [_vm._v(" "+_vm._s(_vm.formatDate(expires))+" ")]}}])}),_c('vbt-pagination',{attrs:{"items-count":_vm.pagedItemsCount},model:{value:(_vm.pageNum),callback:function ($$v) {_vm.pageNum=$$v},expression:"pageNum"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }